module.exports = __webpack_public_path__ + "img/horizontal_6_2_pp2_7.9a0ae8f2.png";